module.exports = "pegasus_template/assets/grayrect-facebook.png";